import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class MainMenuStreamService {
    public showMainMenu$: Subject<boolean> = new Subject();
}
